import { TChatUiModel } from './chat-ui.types';

export const CHAT_UI_TASKS = {
  resetQueryText: function <T>(prevModel: TChatUiModel<T>): TChatUiModel<T> {
    return {
      ...prevModel,
      queryValue: '',
    };
  },

  logChatUiModel: function <T>(chatUiModel: TChatUiModel<T>) {
    console.log('[LOG]', chatUiModel);
    return chatUiModel;
  },

  applySendQueryOptions: function <T>(prevModel: TChatUiModel<T>): TChatUiModel<T> {
    const isWaiting = prevModel.options.showWaitingAfterQuerySend;
    return {
      ...prevModel,
      isWaiting,
      isSendBtnDisabled: isWaiting ? prevModel.options.disableSendBtnWhileWaiting : prevModel.queryValue === '',
    };
  },

  applyReceiveResponseOptions: function <T>(prevModel: TChatUiModel<T>): TChatUiModel<T> {
    const isWaiting = !prevModel.options.hideWaitingAfterResponseReceive;
    return {
      ...prevModel,
      isWaiting,
      isSendBtnDisabled: isWaiting ? prevModel.options.disableSendBtnWhileWaiting : prevModel.queryValue === '',
    };
  },

  applyUpdateQueryOptions: function <T>(prevModel: TChatUiModel<T>): TChatUiModel<T> {
    return {
      ...prevModel,
      isSendBtnDisabled: prevModel.isWaiting
        ? prevModel.options.disableSendBtnWhileWaiting
        : prevModel.queryValue === '',
    };
  },
};
